import { NUMBER_FORMATTER_TOKEN } from '@cgs/common';
import {
  TRIFECTA_FREE_SPINS_COUNT_COMPONENT_TOKEN,
  TRIFECTA_START_PAGE_COMPONENT_TOKEN,
  TRIFECTA_LAUNCH_PARAMS_TOKEN,
  TrifectaLaunchParamsDto,
  TrifectaGameHelp,
  TrifectaNumberFormatter,
} from '@cgs/provider-trifecta';
import { Container, InstanceLifetime } from '@cgs/wge';
import {
  ApplicationGameConfig,
  EnvironmentConfig,
  LOCALIZATION_MANAGER_TOKEN,
  LocalizationManager,
} from '@cgs/shared';
import { HELP_POPUP_COMPONENT_TOKEN, REQUIRED_COMPONENTS_PROVIDER_TOKEN } from '@cgs/machines';
import { SantaGameProvider } from './santa-game-provider';
import { SantaFreeSpinsComponent } from './slot/free-spins/santa-free-spins.component';
import { SantaHudSdkModule } from './slot/hud/santa-hud-sdk.module';
import {
  SANTA_START_PAGE_COMPONENT_TOKEN,
  SantaStartPageComponent,
} from './slot/start-page/santa-start-page.component';

export class SantaGameProviderTrifecta extends SantaGameProvider {
  constructor(container: Container) {
    super(container, true);
  }

  public override register(): void {
    super.register();

    const launchParams = this.container.resolve<TrifectaLaunchParamsDto>(
      TRIFECTA_LAUNCH_PARAMS_TOKEN
    );
    const localizationManager = new LocalizationManager(this.container, launchParams.languageId);
    void localizationManager.init();
    this.container.registerValue(LOCALIZATION_MANAGER_TOKEN, localizationManager, {
      lifetime: InstanceLifetime.Singleton,
    });

    this.container.register(
      NUMBER_FORMATTER_TOKEN,
      (container) => new TrifectaNumberFormatter(container),
      {
        lifetime: InstanceLifetime.Singleton,
      }
    );

    SantaHudSdkModule.register(this.container, {
      sdkAdapter: {
        gameTitle: 'Santa',
        gameVersion: ApplicationGameConfig.appVersion,
        hasIntro: true,
        hasBuyFeatures: true,
        enableAutoReplay: false,
        // all builds run the production webpack pipeline now, so NODE_ENV can't
        // tell a dev stand from production — the environment config can
        isDebug: EnvironmentConfig.isCheatEnabled,
      },
      gameHook: {
        machineId: 7,
        fastSpins: {
          firstSpeed: 1.25,
          secondSpeed: 1.5,
        },
        skipDoStopOnMaxSpeed: true,
      },
    });

    this.container.register(
      SANTA_START_PAGE_COMPONENT_TOKEN,
      (container) => new SantaStartPageComponent(container),
      { lifetime: InstanceLifetime.Singleton }
    );

    this.container.register(
      TRIFECTA_START_PAGE_COMPONENT_TOKEN,
      (container) => container.resolve(SANTA_START_PAGE_COMPONENT_TOKEN),
      { lifetime: InstanceLifetime.Singleton }
    );

    this.container.register(HELP_POPUP_COMPONENT_TOKEN, (c) => new TrifectaGameHelp(c), {
      lifetime: InstanceLifetime.Singleton,
    });

    this.container.register(
      TRIFECTA_FREE_SPINS_COUNT_COMPONENT_TOKEN,
      (container) => new SantaFreeSpinsComponent(container),
      { lifetime: InstanceLifetime.Singleton }
    );

    this.container.registerValue(
      REQUIRED_COMPONENTS_PROVIDER_TOKEN,
      [TRIFECTA_FREE_SPINS_COUNT_COMPONENT_TOKEN, SANTA_START_PAGE_COMPONENT_TOKEN],
      { multi: true }
    );
  }
}
